import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { getClientProfile } from "@/lib/clientStore";
import useConsultantPWAManifest from "@/lib/useConsultantPWAManifest";
import ConsultantHeader from "@/components/ConsultantHeader";
import PracticeForm from "@/components/PracticeForm";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ClientReport() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const profile = getClientProfile();
  const [consultant, setConsultant] = useState(null);

  useConsultantPWAManifest(slug, consultant);

  useEffect(() => {
    if (!profile) {
      navigate(`/c/${slug}/onboarding`);
      return;
    }
    api.get(`/consultants/by-slug/${slug}`)
      .then(({ data }) => setConsultant(data))
      .catch(() => toast.error("Consulente non trovato"));
    // eslint-disable-next-line
  }, [slug]);

  if (!consultant) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-10 h-10 animate-spin text-[#2456C6]" /></div>;
  }

  return (
    <div className="min-h-screen bg-[#F8FAFC] pb-12">
      <ConsultantHeader consultant={consultant} backTo={`/c/${slug}`} />

      <main className="max-w-md mx-auto px-5 py-5">
        <h1 className="text-2xl font-black text-[#1E293B] mb-1">Segnala l&apos;incidente</h1>
        <p className="text-sm text-slate-500 mb-5">Ciao <b>{profile?.first_name}</b>, segui i passi qui sotto.</p>

        <PracticeForm
          initialClient={profile}
          consultantSlug={slug}
          consultant={consultant}
          mode="client"
          showClientFields={false}
          allowedMediaTypes={consultant.allowed_media_types || ["photo"]}
          showDescription={consultant.feature_description !== false}
          onSubmitted={(data) => {
            // If consultant has disabled OTP (quick-acquisition mode), skip signing flow
            if (consultant.feature_otp === false) {
              navigate(`/c/${slug}?submitted=${data.code}`, { replace: true });
            } else {
              navigate(`/c/${slug}/sign/${data.id}?code=${data.code}`);
            }
          }}
        />
      </main>
    </div>
  );
}
